import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Center from './Center';
import IntroText from './IntroText';
import HalfScreenTextParent from './HalfScreenTextParent';
import CenteredTextTest from './CenteredTextTest';
import Fade from 'react-reveal/Fade';
import TiArrowRight from 'react-icons/lib/ti/arrow-right';
import FlexCenter from './FlexCenter';
import rightarrow from './rightarrow.png';
import axios from 'axios';
import Modal from 'react-modal';

class AmenitiesTwo extends Component {
  constructor(){
    super()
    this.state = {
      scrollHeight: document.documentElement.scrollTop,
      newReactKey: 1
    }
  }
  componentWillMount(){
    this.props.changeClass()
  }
  componentDidMount(){
    window.addEventListener('scroll', () => this.setState({scrollHeight: document.documentElement.scrollTop}))
    var floorPlanHeight = () => {
      if(document.getElementById('contact-section')){
        var fph = document.getElementById('contact-section').offsetHeight;
        this.setState({newReactKey: (fph/window.innerHeight)})
      } else {
        this.setState({newReactKey: 1})
      }
    }
    floorPlanHeight();
  }
  componentWillUnmount(){
    window.removeEventListener('scroll', () => this.setState({scrollHeight: document.documentElement.scrollTop}))
  }
  render(){
    var s = this.state, p = this.props;
    return (
      <div>
        <IntroText title={furnishedLivingObj.title} text1={furnishedLivingObj.text1} text2={furnishedLivingObj.text2}/>
        <div id="amenities-page">
          <div className="contact-page-frame">
            <div style={{padding: '0 6%'}}>
              <div>
                <div className="ut-container">
                  <table className="amenities-table unit-table-el unit-table-hide">
                    <tbody>
                      <tr className="tableHeadingRow">
                        <th className="categoryText unitNumCol">Unit #</th>
                        <th className="categoryText typeCol">Property</th>
                        <th className="categoryText typeCol">Type</th>
                        <th className="categoryText floorPlanCol">Amenities</th>
                      </tr>
                      {AllFloorPlans.map((i) => {
                        if(i.available || !p.available){
                          return(
                            <tr className="tableDataRow">
                              <th>{i.unitNum}</th>
                              <th>{i.property}<br/>{i.city}</th>
                              <th>{i.bedroomText}</th>
                              <th style={{textAlign: 'justify'}}>{i.amenities}</th>
                            </tr>
                          );
                        }
                        })}
                    </tbody>
                  </table>
                      {AllFloorPlans.map((i) => {
                        if(i.available || !p.available){
                        return (
                          <div className="hide-table-large">
                            <div className="floorplanMobileHeading"><span className="floorplanMobileUnit">{"#" + i.unitNum + " " + i.property}</span><br/><span className="floorplanMobileCity">{i.city}</span></div>
                            <table className="unit-table-el">
                              <tbody className="unit-table-el">
                                  <tr style={{borderTop: 'none', backgroundColor: '#f7f7f7'}} className="tableDataRow">
                                    <th className="categoryText">Type</th>
                                    <th className="categoryText sqFtCol">Sq Ft</th>
                                    <th className="categoryText rateCol">Price / Mo</th>
                                    <th className="categoryText floorPlanCol">Floor Plan</th>
                                  </tr>
                                  <tr className="tableDataRow">
                                    <th>{i.bedroomText}</th>
                                    <th>{i.sqFt}</th>
                                    <th>{i.price}</th>
                                    <th>
                                      <button className="button-2d-3d floorplan-2d" onClick={() => this.launchModal(i.link)}>
                                        <p>3D Tour </p>
                                      </button>
                                      <button className="button-2d-3d floorplan-3d" onClick={() => console.log('click')}>
                                        <p>Floorplan</p>
                                      </button>

                                    </th>
                                  </tr>
                              </tbody>
                            </table>
                            <div className="amenitiesColBody">
                              <span style={{fontWeight: '900'}}>Amenities:</span> {i.amenities}
                            </div>
                          </div>
                        )
                      }
                        })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AmenitiesTwo;

const Montana135 = '135 Montana Ave';
const Montana435 = '435 Montana Ave';
const Rangely8900 = '8900 Rangely Ave';
const Santa_Monica = 'Santa Monica';
const West_Hollywood = 'West Hollywood';

const AllFloorPlans = [
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 1 bath",
    unitNum: "1",
    property: Montana135,
    sqFt: "735",
    city: Santa_Monica,
    price: "$6,250",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 0,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK',
    floorplanImgFile: ''
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 2 bath",
    unitNum: "2",
    property: Montana135,
    sqFt: "900",
    city: Santa_Monica,
    price: "$7,450",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 1,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK'
  },
  {
    bedroomType: "Studio",
    bedroomText: "Studio",
    unitNum: "3",
    property: Montana135,
    sqFt: "470",
    city: Santa_Monica,
    price: "$4,400",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 2,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK'
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 1 bath",
    unitNum: "4",
    property: Montana135,
    sqFt: "735",
    city: Santa_Monica,
    price: "$6,250",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 3,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 bedroom",
    unitNum: "5",
    property: Montana135,
    sqFt: "550",
    city: Santa_Monica,
    price: "$4,850",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 4,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK'
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 2 bath",
    unitNum: "6",
    property: Montana135,
    sqFt: "900",
    city: Santa_Monica,
    price: "$7,450",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 5,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 bedroom",
    unitNum: "10",
    property: Montana135,
    sqFt: "670",
    city: Santa_Monica,
    price: "$4,850",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 6,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 bedroom",
    unitNum: "11",
    property: Montana135,
    sqFt: "550",
    city: Santa_Monica,
    price: "$4,850",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 7,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK'
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 2 bath",
    unitNum: "12",
    property: Montana135,
    sqFt: "900",
    city: Santa_Monica,
    price: "$7,450",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 8,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 bedroom",
    unitNum: "14",
    property: Montana135,
    sqFt: "621",
    city: Santa_Monica,
    price: "$4,850",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 9,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK'
  },
  {
    bedroomType: "Studio",
    bedroomText: "Studio",
    unitNum: "15",
    property: Montana135,
    sqFt: "440",
    city: Santa_Monica,
    price: "$4,400",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 10,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 bedroom",
    unitNum: "18",
    property: Montana135,
    sqFt: "670",
    city: Santa_Monica,
    price: "$4,850",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 12,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK'
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 2 bath",
    unitNum: "B",
    property: Montana435,
    sqFt: "1,500",
    city: Santa_Monica,
    price: "$9,000",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Office, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, fireplace, All-in-one Printer',
    key: 13,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK'
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 2 bath",
    unitNum: "C",
    property: Montana435,
    sqFt: "1,500",
    city: Santa_Monica,
    price: "$9,000",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Office, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, fireplace, All-in-one Printer',
    key: 14,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK'
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 2 bath",
    unitNum: "WH",
    property: Rangely8900,
    sqFt: "760",
    city: West_Hollywood,
    price: "$8,250",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Office, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, fireplace, All-in-one Printer',
    key: 15,
    link: 'https://my.matterport.com/show/?m=q2eNYW3fCGK'
  }
]

var furnishedLivingObj = {
  title: 'Amenities',
  text1: 'All of our units come fully furnished with a complete kitchen, stainless steel appliances, hardwood floors, marble-tile bathrooms, central air conditioning, utilities, WiFi, Smart TVs & Apple TVs, all-in-one printer, and garage parking',
  text2: 'Our units our thoughtfully furnished and equipped for all of your needs during your stay. Our studios and one bedroom apartments come furnished with a queen mattress, while our two bedrooms have a king in the master and your choice of a queen or twin mattresses in the second bedroom. All of our two bedroom units have a washer & dryer in-unit. Our studios and one bedrooms have a beautiful laundry room on-premise. Our premium two bedrooms feature brick fireplaces.',
  buttonText: 'Explore Floor Plans'
}



// WEBPACK FOOTER //
// ./src/AmenitiesTwo.js